export var dataHooks = {
  tooltipText: 'tooltip-text'
};
export var TIMEOUT = {
  enter: 100,
  exit: 150
};
export var SIZES = {
  small: 'small',
  medium: 'medium'
};